import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { MensagemModel } from '../../../shared/model/chat/mensagens/mensagem-model';
import { MAX_VISIVEIS } from './utils/album-imagens.constantes';

@Component({
  selector: 'app-album-imagens',
  standalone: true,
  imports: [
    DatePipe,
    MatIcon
  ],
  templateUrl: './album-imagens.component.html',
  styleUrl: './album-imagens.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlbumImagensComponent {

  @Input({ required: true }) mensagens: MensagemModel[] = [];
  @Output() abrirMidia = new EventEmitter<MensagemModel>();

  readonly comErro = signal<ReadonlySet<string>>(new Set());

  get ehCliente(): boolean {
    return this.mensagens[0]?.sendBy === 'CLIENTE';
  }

  get visiveis(): MensagemModel[] {
    return this.mensagens.slice(0, MAX_VISIVEIS);
  }

  get excedentes(): number {
    return Math.max(0, this.mensagens.length - MAX_VISIVEIS);
  }

  get ultima(): MensagemModel | undefined {
    return this.mensagens[this.mensagens.length - 1];
  }

  get statusUltima(): string {
    return (this.ultima?.status ?? '').toString().toUpperCase();
  }

  get enviando(): boolean {
    return this.mensagens.some(m => m.enviando);
  }

  aoFalhar(url: string): void {
    const novos = new Set(this.comErro());
    novos.add(url);
    this.comErro.set(novos);
  }

  abrir(mensagem: MensagemModel, event: Event): void {
    event.stopPropagation();
    this.abrirMidia.emit(mensagem);
  }
}
